import React, { useState } from 'react';

type Props = {
    className?: string;
    label: string;
    data: any;
    isToggled: boolean;
    onClick: (data: any) => void;
};

export const ToggleButton: React.FC<Props> = ({ className, label, data, onClick, isToggled = false }) => {
    const onToggled = () => {
        onClick(data);
    };

    return (
        <button
            onClick={(e) => {
                e.preventDefault();
                onToggled();
            }}
            className={`toggle-button
                ${className ? ` ${className}` : ''}
                ${isToggled ? ' active' : ''}`}
        >
            {label}
        </button>
    );
};
